import { render, staticRenderFns } from "./TechGraphic.vue?vue&type=template&id=675f9752&scoped=true"
import script from "./TechGraphic.vue?vue&type=script&lang=js"
export * from "./TechGraphic.vue?vue&type=script&lang=js"
import style0 from "./TechGraphic.vue?vue&type=style&index=0&id=675f9752&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "675f9752",
  null
  
)

export default component.exports